module.exports = __webpack_public_path__ + "media/images/lb/067-d359d8d8c9df3c45ecf40b4dc2c86d98.svg";